<template>
  <div>
    <v-alert :type="alertType" v-model="alertActive" dismissible outline>
      {{ alertMessage }}
    </v-alert>
    <v-dialog v-model="dialog_del" max-width="290">
      <v-card>
        <v-card-title
          class="warning white--text headline justify-space-between"
          >{{ $t('delete_text') }}</v-card-title
        >

        <v-card-text>{{ $t('are_you_sure') }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="secondary darken-1"
            flat="flat"
            @click="dialog_del = false"
            >{{ $t('back') }}</v-btn
          >

          <v-btn color="red darken-1" flat="flat" @click="delOnServer()">{{
            $t('delete')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar flat color="primary">
      <v-toolbar-title class="white--text">{{
        $t('erc_registration')
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('search')"
        single-line
        hide-details
        clearable
        solo
      ></v-text-field>
      <v-dialog v-model="dialog" max-width="800px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary-darken5" dark class="mb-2" v-on="on">
            {{ $t('new_ecr') }}
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.desc"
                    :label="$t('ecr_name')"
                    :error-messages="nameErrors"
                    :counter="60"
                    required
                    @input="$v.editedItem.desc.$touch()"
                    @blur="$v.editedItem.desc.$touch()"
                  ></v-text-field>
                </v-flex>
                <v-flex v-show="editedIndex < 0" xs12 sm3 md3>
                  <v-text-field
                    v-model="editedItem.serial"
                    :label="$t('serial_no')"
                    :error-messages="serialErrors"
                    :counter="16"
                    required
                    @input="$v.editedItem.serial.$touch()"
                    @blur="$v.editedItem.serial.$touch()"
                  ></v-text-field>
                </v-flex>
                <v-flex v-show="editedIndex < 0" xs12 sm3 md3>
                  <v-text-field
                    v-model="editedItem.code"
                    :label="$t('code')"
                    :error-messages="codeErrors"
                    :counter="10"
                    required
                    @input="$v.editedItem.code.$touch()"
                    @blur="$v.editedItem.code.$touch()"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      block
                      :loading="loading"
                      :disabled="serialErrors.length > 0 || loading"
                      color="primary"
                      v-on="on"
                      @click="sendEmail(editedItem.serial)"
                      >{{ $t('send_code') }}</v-btn
                    >
                  </template>
                  <span>{{ $t('send_code_tooltip') }}</span>
                </v-tooltip>
              </v-layout>
              <v-layout row wrap>
                <v-alert
                  type="success"
                  v-model="alertemail"
                  dismissible
                  outline
                  >{{ emailMessage }}</v-alert
                >
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" flat @click="close">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn
              color="primary darken-1"
              flat
              @click="save"
              :disabled="isDisable"
              >{{ $t('save') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="ecrs"
      class="elevation-1"
      :search="search"
    >
      <template v-slot:items="props">
        <td>{{ props.item.desc }}</td>
        <td>{{ props.item.device.sn }}</td>
        <td>{{ props.item.device.devicestatus.ecr1_fw }}</td>
        <td>{{ props.item.device.devicestatus.ecr1_model }}</td>
        <td>{{ props.item.device.devicestatus.version }}</td>
        <td>
          <v-chip
            v-for="lic in props.item.device.license_set"
            :key="lic.type.id"
            small
            :color="lic.status < 100 ? '#e0e0e0' : '#0ef16d'"
            >{{ lic.type.name }}</v-chip
          >
        </td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
          <v-icon small @click="openPage(props.item.device.sn)"
            >settings_applications</v-icon
          >
        </td>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">{{
          $t('your_search {search}', { search: search })
        }}</v-alert>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
import { validationMixin } from 'vuelidate'
import {
  required,
  maxLength,
  numeric,
  minLength
} from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],

  validations: {
    editedItem: {
      desc: { required, maxLength: maxLength(60) },
      serial: { required, maxLength: maxLength(16), minLength: minLength(5) },
      code: {
        required,
        maxLength: maxLength(10),
        minLength: minLength(1),
        numeric
      }
    }
  },
  data() {
    return {
      dialog_del: false,
      dialog: false,
      edit: false,
      alertActive: false,
      alertType: 'success',
      alertMessage: '',
      search: '',
      headers: [
        {
          text: this.$t('ecr_name'),
          align: 'left',
          sortable: true,
          value: 'desc'
        },
        { text: this.$t('serial'), value: 'device.sn' },
        { text: this.$t('fw'), value: 'device.devicestatus.ecr1_fw' },
        { text: this.$t('model'), value: 'device.devicestatus.ecr1_model' },
        { text: this.$t('version'), value: 'device.devicestatus.version' },
        { text: this.$t('buyed_licenses'), value: 'license' }
      ],
      ecrs: [],
      editedIndex: -1,
      editedItem: {
        desc: '',
        serial: '',
        code: ''
      },
      defaultItem: {
        desc: '',
        serial: '',
        code: ''
      },
      nameRules: [v => !!v || this.$t('name_is_required')],
      loading: false,
      emailMessage: '',
      alertemail: false,
      delItem: null
    }
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? this.$t('new_ecr') : this.$t('edit_ecr')
    },
    isDisable() {
      if (this.editedIndex === -1) {
        this.$v.$touch()
        if (this.$v.$invalid) {
          return true
        } else {
          return false
        }
      } else {
        this.$v.$touch()
        if (this.nameErrors.length < 1) {
          return false
        } else {
          return true
        }
      }
    },
    allowButt() {
      if (!this.$v.editedItem.serial.$dirty) return false
      return true
    },
    nameErrors() {
      const errors = []
      if (!this.$v.editedItem.desc.$dirty) return []
      !this.$v.editedItem.desc.maxLength &&
        errors.push(this.$t('must_be_60_characters_long'))
      !this.$v.editedItem.desc.required &&
        errors.push(this.$t('desc_is_required'))
      return errors
    },
    codeErrors() {
      const errors = []
      if (!this.$v.editedItem.code.$dirty) return []
      !this.$v.editedItem.code.maxLength &&
        errors.push(this.$t('must_be_10_characters_long'))
      !this.$v.editedItem.code.minLength &&
        errors.push(this.$t('must_be_10_characters_long'))
      !this.$v.editedItem.code.required &&
        errors.push(this.$t('code_is_required'))
      !this.$v.editedItem.code.numeric && errors.push(this.$t('code_numeric'))
      return errors
    },
    serialErrors() {
      const errors = []
      if (!this.$v.editedItem.serial.$dirty) return []
      !this.$v.editedItem.serial.maxLength &&
        errors.push(this.$t('must_be_8_characters_long'))
      !this.$v.editedItem.serial.minLength &&
        errors.push(this.$t('must_be_8_characters_long'))
      !this.$v.editedItem.serial.required &&
        errors.push(this.$t('serial_is_required'))
      return errors
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    async initialize() {
      try {
        this.$root.$loader(true)
        let res = await this.axios.get('/api/cashregister/')
        this.ecrs = res.data
      } catch (e) {
        this.$root.$gerror(e.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },

    editItem(item) {
      this.editedIndex = this.ecrs.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      this.dialog_del = true
      this.delItem = Object.assign({}, item)
    },
    async delOnServer() {
      try {
        this.dialog_del = false
        const index = this.ecrs.indexOf(this.delItem)
        this.ecrs.splice(index, 1)
        this.$root.$loader(true)
        await this.axios.delete(
          `/api/cashregister/${this.delItem.device_id}`,
          this.delItem
        )
      } catch (e) {
        this.$root.$gerror(e.response.data)
      } finally {
        this.initialize()
      }
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save() {
      try {
        this.$root.$loader(true)
        if (this.editedIndex > -1) {
          Object.assign(this.ecrs[this.editedIndex], this.editedItem)
          let r = await this.axios.put(
            `/api/cashregister/${this.editedItem.device_id}/`,
            this.editedItem
          )
          if (r.status == 200) {
            this.showAlert(this.$t('ecr_succ_edited'), 'success')
          }
        } else {
          let r = await this.axios.post(`/api/cashregister/`, this.editedItem)
          if (r.status == 200) {
            this.showAlert(this.$t('ecr_succ_added'), 'success')
          }
        }
      } catch (e) {
        this.$root.$gerror(e.response.data)
      } finally {
        this.initialize()
        this.close()
      }
    },
    showAlert(message, type) {
      this.alertMessage = message
      this.alertType = type
      this.alertActive = true
      setTimeout(() => (this.alertActive = false), 10000)
    },
    async openPage(sn) {
      try {
        this.$root.$loader(true)
        let r = await this.axios.get(`/api/ecr-test/${sn}`)
        if (r.status === 204) {
          window.open(this.$proxyURL + `/ecrproxy/${sn}`, '_blank')
        }
      } catch (error) {
        this.$root.$gerror({
          Code: 901,
          Message: `Nelze se připojit k pokladně
                    Možné důvody:
                      - Není aktualizována pokladna
                      - Pokladna je vypnutá
                      - Není povolena vzdálená zpráva v modulu pokladny`
        })
      } finally {
        this.$root.$loader(false)
      }
    },
    async sendEmail(sn) {
      this.loading = true
      try {
        await this.axios.get(`/api/license-email-code?sn=${sn}`)
        this.emailMessage = this.$t('email_send_succ')
        this.alertemail = true
      } catch (e) {
        this.$root.$gerror(e.response.data)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.my-text-style >>> .v-text-field__slot input {
  color: white;
}
</style>
